declare var $: any;
declare var GlobalPayments: any;
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { AuthorizationBase } from '../../../core/authorize-base';
import { paymentCss } from '../../../formiobuilder/models/globalpayments.model';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CreditPaymentService } from '../../services/creditpayment.service';

@Component({
  selector: 'app-heartland-card-tokenizer',
  templateUrl: './heartland-card-tokenizer.component.html',
  styleUrls: ['./heartland-card-tokenizer.component.scss'],
})
export class HeartlandCardTokenizerComponent
  extends AuthorizationBase
  implements OnInit
{
  form: FormGroup;
  field: any;
  cardToken: any;
  busy: boolean;
  tokenizerBusy: boolean;
  @Input() source: string = '';
  @Input() publicAPIKey: string;
  @Input() submitText = 'Add new customer card';
  @Output() tokenData = new EventEmitter();

  constructor(
    private creditService: CreditPaymentService,
    private toastr: ToastrService,
    private apiService: ApiService
  ) {
    super();
  }

  ngOnInit() {
    let apiKey = this.getAPIKey();

    let self = this;
    GlobalPayments.configure({
      publicApiKey: apiKey,
    });
    // Create Form
    const cardForm = GlobalPayments.ui.form({
      fields: {
        'card-holder-name': {
          placeholder: 'Jane Smith',
          target: '#credit-card-card-holder',
        },
        'card-number': {
          placeholder: '•••• •••• •••• ••••',
          target: '#credit-card-card-number',
        },
        'card-expiration': {
          placeholder: 'MM / YYYY',
          target: '#credit-card-card-expiration',
        },
        'card-cvv': {
          placeholder: '•••',
          target: '#credit-card-card-cvv',
        },
        submit: {
          text: this.submitText,
          target: '#credit-card-submit',
        },
      },
      styles: paymentCss(),
    });

    cardForm.on('card-number', 'token-success', function (resp) {
      cardForm.frames['card-cvv'].getCvv().then(function (c) {
        resp.details.cvv = c;
        self.onTokenSuccess(resp);
      });
    });

    cardForm.on('card-number', 'token-error', function (resp) {
      self.onTokenError(resp);
    });

    cardForm.on('submit', 'click', () => {
      this.tokenizerBusy = true;
    });

    var paymentRequestForm = GlobalPayments.paymentRequest.setup(
      '#credit-card-submit',
      {
        total: {
          label: 'Total',
          amount: { value: 10, currency: 'USD' },
        },
      }
    );

    paymentRequestForm.on('token-success', function (resp) {
      self.onTokenSuccess(resp);
      GlobalPayments.paymentRequest.complete('success');
    });

    paymentRequestForm.on('token-error', function (resp) {
      self.onTokenError(resp);
    });

    paymentRequestForm.on('error', function (resp) {
      self.onTokenError(resp);
    });
  }

  onTokenSuccess(res) {
    this.cardToken = res;
    this.tokenData.emit(res);
  }

  onTokenError(res) {
    if (res.error) {
      this.toastr.error(res.reasons[0].message, res.reasons[0].code);
      this.tokenizerBusy = false;
    }
  }

  setBusyState(state: boolean) {
    this.tokenizerBusy = state;
  }

  checkIfSandboxEnabled() {
    //check if use sandbox is set to true
    this.apiService
      .get(`account/configuration/get?name=Sandbox.IsEnabled`)
      .subscribe((response: any) => {
        if (!response) {
          this.toastr.error(
            'Please set Sandbox.IsEnabled configuration.',
            'Missing Sandbox.IsEnabled configuration.'
          );
          return false;
        } else {
          if (response.Value.toString() === 'TRUE') {
            return true;
          } else {
            return false;
          }
        }
      });

    return false;
  }

  getSandboxPublicKey() {
    this.apiService
      .get(`account/configuration/get?name=Sandbox.PublicAPIKey`)
      .subscribe(
        (response: any) => {
          if (!response) {
            this.toastr.error(
              'Please set Sandbox.IsEnabled configuration.',
              'Missing Sandbox.IsEnabled configuration.'
            );
            return false;
          } else {
            let apiKey = response.Value.toString();
            console.log(apiKey);
            return apiKey;
          }
        },
        (error: any) => {
          let msg = 'Error encountered';
          let ctr = 0;
          while (true && ctr < 10) {
            if (error.error === undefined) {
              msg = error.message;
              break;
            }
            ctr++;
            error = error.error;
          }
          this.toastr.error(msg, 'Error');
        },
        () => {}
      );
    return false;
  }

  getAPIKey() {
    let userid = super.userId();
    if (userid === '0') {
      let isSandboxEnabled = this.checkIfSandboxEnabled();
      if (isSandboxEnabled) {
        return this.getSandboxPublicKey();
      }
    }

    let locationData = super.getCurrentLoginUserLocation(); //TODO RESOLVE THIS SUCH THAT THE API KEY DATA IS ALSO AVAILABLE FOR THE CUSTOMER INVOICE
    let apiKey = locationData ? locationData.Public_API_Key : this.publicAPIKey;
    if (!apiKey) {
      this.toastr.error(
        'Please set API Keys before using Card Payment. They can be configured by going to Locations > Edit Location > MID, PUBLIC API KEY and SECRET API KEY fields.',
        'Missing API Keys'
      );
      return false;
    }

    return apiKey;
  }
}
